import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import sortBy from 'lodash/sortBy';
import {
  fetchCategoriesIfNeeded, getSubCategories, excludeDeprecated
} from 'common/ducks/categories';
import CategorySlider from 'landing_pages/components/categories_slider';

export function mapStateToProps(state, { sortByPopularity }) {
  const cats = excludeDeprecated(state.categories.data).filter(c => !c.is_one_to_one);
  let subcats = cats.reduce((acc, cat) => acc.concat(cat.subcategories), []);
  subcats = sortByPopularity? sortBy(subcats, s => !s.is_popular) : subcats;
  return { cats: subcats };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCategoriesIfNeeded,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CategorySlider));
